.logo {
  display: flex;

  > * {
    max-width: 100%;
    height: 1em;
  }
}
